import SafeImage from '@ui/SafeImage';
import { StaticImageData } from 'next/image';

export type SellingReasonType = {
  description: string;
  name: string;
  image: StaticImageData;
};

const ImageCover = ({ className }: { className?: string }) => (
  <div className={className}>
    <svg
      width="282"
      height="24"
      viewBox="0 0 282 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M282 0L246.75 15L211.5 12.8276L176.25 18.4138L141 15L105.75 3L70.5 9L35.25 3L0 9V24H35.25H70.5H105.75H141H176.25H211.5H246.75H282V0Z"
        fill="white"
      />
    </svg>
  </div>
);

const WhySellOnMxLocker = ({ description, name, image }: SellingReasonType) => {
  return (
    <div className="flex-1">
      <div className="flex h-full  flex-col items-center ">
        <div className="relative overflow-x-hidden">
          <SafeImage alt={'image'} src={image} className="w-full" />
          <ImageCover className="absolute bottom-0 left-0" />
        </div>
        <div className="mt-[1.6rem] text-center text-[1.8rem] font-semibold">
          {name}
        </div>
        <div className="mt-[1.6rem] text-center text-[1.4rem] font-normal">
          {description}
        </div>
      </div>
    </div>
  );
};

export default WhySellOnMxLocker;
